import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  BOARDS_APPROVE,
  MEMBERS_PROFILE_APPROVE,
  UNAPPROVE_NGWORD_LIST,
} from 'manager/http-constants';
import { CONSTANT } from 'src/app/shared/constant/constant';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { PlatformComponent } from '../../platform.component';
import { ApprovalDialogComponent } from '../../common/approval-dialog/approval-dialog.component';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-d271',
  templateUrl: './d271.component.html',
  styleUrls: [
    '../secretariat-list.component.scss',
    '../../platform.component.scss',
  ],
})

/**
 * 掲示板コメント審査
 */
export class D271Component extends PlatformComponent {
  /** 共通部品_承認時ダイアログ */
  @ViewChild(ApprovalDialogComponent)
  approvalDialogComponent: ApprovalDialogComponent;

  // 画面.検索フォーム
  d271SearchForm: FormGroup = this.formBuilder.group({
    //ステータス・ シングルセレクト
    status: '1',
    // 期間日from
    date1: CONSTANT.EMPTY_STRING,
    // 期間日to
    date2: CONSTANT.EMPTY_STRING,
  });

  /** テーブル状態 */
  @ViewChild('table') table: Table;

  //ステータス取得格納先
  statusList: object[] = [
    {
      sp_name: '全て',
      sp_code: '0',
    },
    {
      sp_name: '公開（未確認）',
      sp_code: '1',
    },
    {
      sp_name: '公開（確認済み）',
      sp_code: '2',
    },
    {
      sp_name: '非公開',
      sp_code: '3',
    },
  ];

  // 未承認一覧（掲示板コメント）格納先
  resultTaskDataList: object[] = new Array();

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  ngOnInit(): void {
    // 未承認一覧（掲示板コメント）を取得
    this.getResultTaskDataList();
  }

  /**
   * 未承認一覧（掲示板コメント）を取得
   */
  public getResultTaskDataList(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(UNAPPROVE_NGWORD_LIST);

    // 未承認一覧（掲示板コメント）を取得
    this.dbOperationService
      .getNoTemplateData(
        UNAPPROVE_NGWORD_LIST,
        this.d271SearchForm.value,
        false
      )
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // 未承認一覧（掲示板コメント）を格納
          this.resultTaskDataList = response.body;
        } else {
          this.resultTaskDataList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, UNAPPROVE_NGWORD_LIST);
      });

    // テーブル状態が存在するか否か
    if (this.table) {
      // テーブル状態が存在する場合

      // テーブル状態をリセット
      this.table.reset();
    }
  }

  /**
   * 会員プロフィール(B211 or B212)へ遷移する
   * @param resultTaskData 結果情報
   */
  public moveB211orMoveB212(resultTaskData: any): void {
    // 自治体 or 事務局ユーザが否か
    if (1 == resultTaskData.class_id || 9 == resultTaskData.class_id) {
      // 会員プロフィール(自治体)(B211)へ遷移
      this.router.navigate(['pages/platform/b211/' + resultTaskData.member_id]);
    } else {
      // 会員プロフィール(民間団体)(B212)へ遷移
      this.router.navigate(['pages/platform/b212/' + resultTaskData.member_id]);
    }
  }

  /**
   * 内閣府承認ダイアログ表示
   * @param boardId 掲示板ID
   * @param memberId 会員ID
   * @param dataname データ情報
   */
  public openSmallApprovalDialog(boardId: string, memberId: string, dataname: string): void {

    event.stopPropagation();

    // 内閣府承認ダイアログ表示
    if ('掲示板コメント' == dataname) {
      this.approvalDialogComponent.openSmallApprovalDialog(
        BOARDS_APPROVE,
        boardId,
        2008
      );
    } else {
      this.approvalDialogComponent.openSmallApprovalDialog(
        MEMBERS_PROFILE_APPROVE,
        memberId,
        2002
      );
    }
  }

  /**
   * 課題・ソリューションの詳細画面(C301)へ遷移する
   * @param resultTaskData 結果情報
   */
   public moveC301(resultTaskData: any): void {
    // 課題・ソリューションの詳細画面(c301)へ遷移
    this.router.navigate(['pages/platform/c301/' + resultTaskData.agenda_id]);
  }

}
